import ShippingSettings from './ShippingSettings';

export default ShippingSettings;


// WEBPACK FOOTER //
// ./src/scenes/OrderView/OrderView/ShippingSettings/index.tsx